/**
 * 說明 : 住戶資料與後端調用的非同步行為
 */

// ----- import from redux toolkit -----
import { createAsyncThunk } from "@reduxjs/toolkit";

// ----- import from Base API -----
import BaseAPI from "./BaseAPI";

// 新增住戶
export const addResident = createAsyncThunk(
    "resident/addResident",
    async (resident, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.postWithAuth("/setting/resident", resident, token);
            return data;
        } catch (err) {
            console.error('add resident error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 修改住戶
export const editResident = createAsyncThunk(
    "resident/editResident",
    async (resident, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth("/setting/resident", resident, token);
            return data;
        } catch (err) {
            console.error('edit resident error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 修改住戶狀態
export const editResidentStatus = createAsyncThunk(
    "resident/editResidentStatus",
    async ({applicantIds, status }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth("/setting/resident/status", {applicantIds: applicantIds, flgStatus: status }, token);
            return data;
        } catch (err) {
            console.error('edit resident status error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 取得單筆住戶資料
export const fetchResident = createAsyncThunk(
    "resident/fetchResident",
    async (residentId, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth(`/setting/resident/${residentId}`, token);
            return data;
        } catch (err) {
            console.error('fetch resident error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 取得住戶清單列表
export const fetchResidentList = createAsyncThunk(
    "resident/fetchResidentList",
    async ({ buildingId, houseNum, elevatorId, floorDisplay }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth("/setting/resident", { buildingId: buildingId, houseNum: houseNum, elevatorId: elevatorId, floorDisplay: floorDisplay }, token);
            return data;
        } catch (err) {
            console.error('fetch resident list error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 匯入住戶資料
export const importResident = createAsyncThunk(
    "resident/importResident",
    async ({ residents }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.postWithAuth("/setting/resident/import", { residents: residents }, token);
            return data;
        } catch (err) {
            console.error('import resident error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);